import { render } from "./CheckRadioPicker.vue?vue&type=template&id=82b785e0"
import script from "./CheckRadioPicker.vue?vue&type=script&lang=js"
export * from "./CheckRadioPicker.vue?vue&type=script&lang=js"

import exportComponent from "/var/www/html/pip-frontend/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__